import { connect } from 'react-redux';

import paymentGatewaysActionCreators from '_store/_actions/companyPaymentGateways';

import GatewayForm from './GatewayForm';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,

  availablePaymentGateways: state.companyPaymentGateways.availablePaymentGateways,

  paymentGateways: state.companyPaymentGateways.paymentGateways,
});

const mapDispatchToProps = {
  onFetchCompanyPaymentGateway: paymentGatewaysActionCreators.fetchPaymentGateway,
  onCreateCompanyPaymentGateway: paymentGatewaysActionCreators.createPaymentGateway,
  onUpdateCompanyPaymentGateway: paymentGatewaysActionCreators.updatePaymentGateway,
  onDeleteCompanyPaymentGateway: paymentGatewaysActionCreators.deletePaymentGateway,
  onPerformCompanyPaymentGatewayAction:
    paymentGatewaysActionCreators.performPaymentGatewayAction,
  onFetchPaymentGatewayWebhooks:
    paymentGatewaysActionCreators.fetchPaymentGatewayWebhooks,
  onCreatePaymentGatewayWebhook:
    paymentGatewaysActionCreators.createPaymentGatewayWebhook,
  onUpdatePaymentGatewayWebhook:
    paymentGatewaysActionCreators.updatePaymentGatewayWebhook,
  onDeletePaymentGatewayWebhook:
    paymentGatewaysActionCreators.deletePaymentGatewayWebhook,
  onFetchPaymentGatewayWebhookEvents:
    paymentGatewaysActionCreators.fetchPaymentGatewayWebhookEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(GatewayForm);
